<template>
  <v-autocomplete
    v-model="selected"
    :items="items"
    small-chips
    :label="$t('selectUsersGroups')"
    item-text="display"
    item-value="id"
    hide-no-data
    hide-selected
    deletable-chips
    :menu-props="{
      closeOnContentClick: true
    }"
    multiple
    :error-messages="errors"
  >
    <template slot="item" slot-scope="{ item }">
      <template v-if="item.type === 'header'">
        <v-list-item-content v-text="item.display"></v-list-item-content>
      </template>
      <template v-if="item.type === 'group'">
        <v-list-item-avatar size="32px">
          <v-icon light v-text="$vuetify.icons.values.groups" class="fa-fw"></v-icon>
        </v-list-item-avatar>
        <v-list-item-content v-text="item.display"></v-list-item-content>
      </template>
      <template v-if="item.type === 'user'">
        <v-list-item-avatar size="32px">
          <img :src="item.avatar" />
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title v-html="item.display"></v-list-item-title>
        </v-list-item-content>
      </template>
    </template>
  </v-autocomplete>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import { NAMESPACE as GROUP_NAMESPACE } from '@argon/iam/groups/store'
import { NAMESPACE as ORG_NAMESPACE } from '@argon/iam/organizations/store'
export default {
  name: 'UserGroupField',
  props: {
    updateSelection: Function,
    selection: Array,
    errors: Array,
    required: Boolean,
    provided: Array
  },
  methods: {
    ...mapActions(GROUP_NAMESPACE, ['listGroups']),
    ...mapActions(ORG_NAMESPACE, ['listCurrentOrgUsers'])
  },
  computed: {
    ...mapState(GROUP_NAMESPACE, ['groups']),
    ...mapState(ORG_NAMESPACE, ['users']),
    selected: {
      get() {
        return this.selection
      },
      set(value) {
        this.updateSelection(value)
      }
    },
    items() {
      return this.provided
        ? this.provided
        : [
            { header: this.$t('groups') },
            ...this.groups.map((item) => ({ ...item, type: 'group' })),
            { header: this.$t('users') },
            ...this.users.map((item) => ({ ...item.user, type: 'user' }))
          ]
    }
  },
  created() {
    let shouldFetch = this.users.length === 0 || this.groups.length === 0
    if (!this.provided && shouldFetch) {
      Promise.all([this.listGroups({}), this.listCurrentOrgUsers({})]).catch(() => {})
    }
  }
}
</script>

<i18n>
{
  "en": {
    "groups": "@:labels.groups",
    "selectUsersGroups": "Select Users or Groups",
    "users": "@:labels.users"
  },
  "fr": {
    "groups": "@:labels.groups",
    "selectUsersGroups": "Choisir les utilisateurs où les groupes",
    "users": "@:labels.users"
  }
}
</i18n>
